import { Header,ImgGallery } from '../components'

const GalleryPage = () => {
    return (
        <main>
            <Header icon='far fa-images page-icon'/>
            <ImgGallery/>
        </main>
    )
}

export default GalleryPage
